import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatSidenavModule } from '@angular/material/sidenav';
import { RouterModule } from '@angular/router';
import { driverTranslations } from '@fleet/driver-shared/translations/driver-translation-loader';
import { FuseLoadingBarModule } from '@fleet/fuse';
import { SettingsTabLabelModule } from '@fleet/ui/settings-tab-label/settings-tab-label-module';
import { provideTranslocoScope, TranslocoModule } from '@jsverse/transloco';
import { NativeAppWebviewLayoutComponent } from './native-app-webview-layout.component';
@NgModule({
  declarations: [NativeAppWebviewLayoutComponent],
  imports: [
    RouterModule,
    CommonModule,
    MatSidenavModule,
    MatIconModule,
    TranslocoModule,
    FuseLoadingBarModule,
    SettingsTabLabelModule,
  ],
  providers: [
    provideTranslocoScope({
      scope: 'driverMenu',
      loader: driverTranslations,
    }),
  ],
  exports: [NativeAppWebviewLayoutComponent],
})
export class NativeAppWebviewLayoutModule {}
